// test308
(308 && 0);
